import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { usePermissionGuardRedirect } from "../../../../hooks/usePermissionGuard";
import { getUpcomingEventDetails } from "../../../../services/EventService";
import { getEventsAuditTrailList, getEventsAuditTrailListFilters } from "../../../../services/WebsiteListServer";
import Header from "../../../common/Header";
import SideBar from "../../../common/SideBar";
import EventAuditTrail from "../../../StudentAdministration/Students/EventAuditTrail";
import Booking from "./Booking";
import EventDetails from "./EventDetails";

function UpcomingEventsTabs() {
    const history = useHistory();
    const { id, tab, subTab, subId="" } = useParams();
    const [eventDetails , setEventDetails] = useState({});
    const [refresh, setRefresh] = useState(false);

    const permissionWbseventupcomingview = usePermissionGuardRedirect(["wbseventupcomingview"]);

    useEffect(() => {
        if (!permissionWbseventupcomingview) {
            return;
        }
        if ((subId && (subTab === "open" || subTab === "update"))) {
            const source = axios.CancelToken.source();
            const fetchEventData = async () => {
                setLoading(true);
                try {
                    const res = await getUpcomingEventDetails(subId, source.token);
                    setEventDetails(res.data.Data);
                } catch (error) {
                    console.error(error);
                    if (error.response.data?.message !== "") {
                        Swal.fire({
                            icon: "Info",
                            title: "Info",
                            text: "No record found with this id"
                        });
                        history.push(`/websiteManagement/events/upcoming_events/table`)
                    }
                } finally {
                    setLoading(false);
                }
            };
            fetchEventData();

            return () => source.cancel("Component unmounted");
        }
    }, [subId, refresh, subTab, permissionWbseventupcomingview]);

    const [loading, setLoading] = useState(true);
    const [headerName, setHeaderName] = useState(() => {
        return localStorage.getItem("headerName") || "";
    });
    const [previewDomain, setPreviewDomain] = useState(() => {
        return localStorage.getItem("previewDomain") || "";
    })
    const [pageID, setPageId] = useState(() => {
        return localStorage.getItem("pageID") || "";
    })
    return (
        <>
            <Header />
            <div className="content-wrapper d-flex flex-wrap">
                <SideBar />
                <div
                    className={
                        "sidebar-right " + (tab === "gradebook" ? "bottom-100" : "")
                    }
                >
                    <div className="sub-menu-content-block">
                        <div className="sub-menu-right-block">
                            <div className="wrap-box-right">
                                <div className="my-tickets-heading-blk flex-direction mb-2">
                                    <div className="d-flex align-items-center ">
                                        <div className="name-w-head d-flex align-items-center ">
                                            <h4 className="text-left-align landing-heading heading_color_dynamic">
                                                {subTab == "create" ? "Upcoming Events: " : "Upcoming Events: "}
                                                <span>{subTab == "create" ? "Create New" : headerName}</span>
                                            </h4>
                                        </div>
                                        <div className="text-md-right action2-blk">
                                            <div className="ticket-view-btn d-flex align-items-center">
                                                <div className="add-new-ticket-bx">
                                                    <button
                                                        onClick={() => history.goBack()}
                                                        title="Back"
                                                        className="btn btn-white-bordered"
                                                    >
                                                        <i className="fal fa-angle-left"></i>Back
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        {pageID && <div className="text-md-right action2-blk">
                                        <div className="ticket-view-btn d-flex align-items-center">
                                        <div className="add-new-ticket-bx">
                                        <a
                                        href={`${previewDomain}/openday?id=${pageID}`}
                                        title="Preview"
                                        target="_blank"
                                        className="btn btn-white-bordered"
                                        >
                                        <i className="fal fa-eye"></i>Preview
                                        </a>
                                        </div>
                                        </div>
                                        </div>
                                    }
                                    </div>
                                </div>
                                <div className="tabs-wrap">
                                    {(subTab === "open") && (
                                        <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                                            <li className="nav-item" onClick={() => history.push(`/websiteManagement/events/upcoming_events/event_details/${subTab}/${subId}`)}>
                                                <Link
                                                    className={`nav-link ${tab === "event_details" && "active"}`}
                                                    id="pills-tab1"
                                                    data-toggle="pill"
                                                    to={`/websiteManagement/events/upcoming_events/event_details/${subTab}/${subId}`}
                                                    role="tab"
                                                    aria-controls="pills-tab11"
                                                    aria-selected="true"
                                                >
                                                    <i className="fa fa-info-circle"></i>
                                                    Event Details
                                                </Link>
                                            </li>
                                             <li className="nav-item" onClick={() => history.push(`/websiteManagement/events/upcoming_events/bookings/${subTab}/${subId}`)}>
                                                <Link
                                                    className={`nav-link ${tab === "bookings" && "active"}`}
                                                    id="pills-tab1"
                                                    data-toggle="pill"
                                                    to={`/websiteManagement/events/upcoming_events/bookings/${subTab}/${subId}`}
                                                    role="tab"
                                                    aria-controls="pills-tab11"
                                                    aria-selected="true"
                                                >
                                                    <i className="fa fa-calendar-alt"></i>
                                                    Bookings
                                                </Link>
                                            </li>
                                            <li className="nav-item" onClick={() => history.push(`/websiteManagement/events/upcoming_events/auditTrail/${subTab}/${subId}`)}>
                                                <Link
                                                    className={`nav-link ${tab === "auditTrail" && "active"}`}
                                                    id="pills-tab2"
                                                    data-toggle="pill"
                                                    to={`/websiteManagement/events/upcoming_events/auditTrail/${subTab}/${subId}`}
                                                    role="tab"
                                                    aria-controls="pills-tab12"
                                                    aria-selected="true"
                                                >
                                                    <i className="fal fa-history"></i>Audit trail
                                                </Link>
                                            </li>
                                        </ul>
                                    )}
                                    <div className="tab-content" id="pills-tabContent">
                                        <div className="tab-pane fade active show" id="pills-tab11" role="tabpanel" aria-labelledby="pills-tab1">
                                            {tab == "event_details" && <EventDetails details={eventDetails} setLoading={setLoading} loading={loading} setPreviewDomain={setPreviewDomain} setPageId={setPageId} setHeaderName={setHeaderName} />}
                                            {tab == "bookings" && <Booking setHeaderName={setHeaderName} />}
                                            {tab == "auditTrail" && <EventAuditTrail apiParams={{ action_id: subId,tab_type: 'Upcoming Events' }} apiFunction={getEventsAuditTrailList} apiFilter={getEventsAuditTrailListFilters} exportName={"landing_page_auditTrail"}/>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UpcomingEventsTabs;
